<template>
  <v-container class="fill-height" fluid>
     <v-row>
          <v-col cols="12">
           <v-img class="mx-auto" :src="logo" contain aspect-ratio="1.5" position="center" max-width="200"></v-img>
            </v-col>
        </v-row>  
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" >
        <v-card class="elevation-12">
          <v-toolbar dark flat>
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-form action="#" @submit.prevent="login">
            <v-card-text>
              <span v-if="error"><strong class="red--text">{{errorText}}</strong></span>
              <v-text-field
                label="username"
                name="username"
                prepend-icon="person"
                type="text"
                id="username"
                :rules="usernameRule"                
                v-model="username"
              />
              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                type="password"
                :rules="passwordRule"
                v-model="password"
              />
               <v-text-field
                id="damnnid"
                label="DamnN ID"
                name="dammNId"
                prepend-icon="key"
                type="text"
                :rules="damnnidRule"
                v-model="DamnnId"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" color="primary">Login</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      username: '',
      password: '',
       DamnnId:'',
      logo: require("@/assets/damnn_group_header.png"),
      error: false,
      errorText: '',
      usernameRule: [
        v => !!v || "Please enter username"
      ],
      passwordRule: [
        v => !!v || "Please enter password"
      ],
       damnnidRule: [
        v => !!v || "Please enter DamnnId"
      ],
    };
  },
  methods: {
    login() {
      this.$store
        .dispatch("retrieveToken", {
          username: this.username,
          password: this.password,
          DamnnId: this.DamnnId, 
        })
        .then(() => {
          this.$store
            .dispatch("retrieveUserDetails")
            .then(() => {
             // this.getadserversessionid();
              this.$router.push({ name: "balances" });
            })
        })
        .catch(error => {
          this.error = true;
          console.log(error.response);
          this.errorText = error.response.data.message;
        });
    }
    ,
     getadserversessionid() {
      this.$store.dispatch("retrieveAdserverSessionid", {
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Session Id error");
          console.log(error);
        });
    }
  }
};
</script>
<style>
.v-responsive__sizer{padding-bottom: 28.33% !important;}
</style>
<style scoped>
.row {
  margin-left: 0px;
}
</style>